module.exports = __webpack_public_path__ + "img/product12.05ccef7e.jpg";